import { Fragment, useCallback } from 'react';
import { setDateObj, compareDateObj } from '@features/calendar/core';
import { useAppDispatch, useAppSelector } from '@hooks/defineRtkTypedHook';
import { setSelectedDate, selectedSelectedDate } from '@features/calendar/CalendarSlice';
import type { IDateObj } from '@type/index';

interface IDateProps {
    dateObj: IDateObj;
    hasMark: boolean;
}

export const Date = ({ dateObj, hasMark }: IDateProps) => {
    const dispatch = useAppDispatch();
    const selectedDate = useAppSelector(selectedSelectedDate);
    const { date, day } = dateObj || {};
    const todayDateObj = setDateObj();
    const isToday = compareDateObj(dateObj, todayDateObj);
    const isSelectedDate = compareDateObj(dateObj, selectedDate);

    const clickHandler = useCallback(() => {
        dispatch(setSelectedDate(dateObj));
    }, [dateObj]);

    return <div className={`date ${isToday ? 'today' : ''} ${isSelectedDate ? 'selected' : ''} ${day === 0 ? 'sunday' : day === 6 ? 'saturday' : ''}`}>
        {
            typeof date === 'number' && date > 0 ? <Fragment>
                <button type="button" onClick={clickHandler} data-contents="달력_날짜_클릭">
                    <strong>{date}</strong>
                    { hasMark ? <div className="mark"></div> : <Fragment /> }
                </button>
            </Fragment> : <Fragment />
        }
    </div>
};